import { render } from "./CarouselSlide.vue?vue&type=template&id=36f52786"
import script from "./CarouselSlide.vue?vue&type=script&lang=js"
export * from "./CarouselSlide.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__